import React, { useCallback } from "react";

import { faCheckCircle } from "@fortawesome/pro-regular-svg-icons/faCheckCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import { IntlShape, useIntl } from "react-intl";

import { Activity } from "@mapmycustomers/shared/types/entity";

import RoundButton from "@app/component/RoundButton";

export const getActivityCompletedActionName = (intl: IntlShape, completed: boolean) =>
  intl.formatMessage(
    {
      id: "activity.completedButton",
      defaultMessage: "{completed, select, true {Done} other {Mark Done}}",
      description: "Label for done button",
    },
    { completed }
  );

interface Props {
  activity: Activity;
  className?: string;
  disabled?: boolean;
  toggleComplete: (activity: Activity) => void;
  toggleCompleteLoadingIds: Activity["id"][];
  tooltip?: string;
}

const ToggleCompleteButton: React.FC<Props> = ({
  activity,
  className,
  disabled,
  toggleComplete,
  toggleCompleteLoadingIds,
  tooltip,
}) => {
  const intl = useIntl();

  const handleToggleActivity = useCallback(() => {
    toggleComplete(activity);
  }, [activity, toggleComplete]);

  return (
    <Tooltip title={tooltip} trigger={["hover"]}>
      <div>
        <RoundButton
          active={activity.completed}
          className={className}
          disabled={disabled}
          leftIcon={<FontAwesomeIcon icon={faCheckCircle} />}
          loading={toggleCompleteLoadingIds.includes(activity.id)}
          onClick={handleToggleActivity}
        >
          {getActivityCompletedActionName(intl, activity.completed)}
        </RoundButton>
      </div>
    </Tooltip>
  );
};

export default ToggleCompleteButton;
